export default {
  en: {
    // Banner section
    slogan: 'Leading Agricultural Machinery Solutions',
    bannerSubtitle: 'Innovative farming equipment for modern agriculture',
    shopNow: 'Shop Now',
    specialOffer: 'Special Offer',
    offerDetails: 'Get special discounts on selected products',
    viewOffer: 'View Offer',

    // Featured products section
    featuredProducts: 'Featured Products',
    viewAllProducts: 'View All Products',
    exploreProducts: 'Explore',
    newArrival: 'New',
    bestSeller: 'Hot',

    // Customer cases section
    customerCases: {
      title: 'Customer Success Stories',
      subtitle: 'Real cases from our global partners',
      procuredProducts: 'Procured Products',
      highlights: 'Key Cooperation Highlights'
    },

    // Company intro section
    companyIntro: {
      title: 'About FUTONDA',
      paragraph1: 'FUTONDA is a leading manufacturer of agricultural machinery, specializing in tractors and farming equipment.',
      paragraph2: 'With over 20 years of experience, we provide innovative solutions for modern agriculture.',
      paragraph3: 'Our products are exported to more than 50 countries worldwide, trusted by farmers globally.',
      paragraph4: 'We focus on quality, innovation, and customer satisfaction.',
      founded: 'Founded',
      capacity: 'Annual Capacity',
      engineers: 'Engineers',
      countries: 'Export Countries',
      viewMore: 'VIEW MORE',
    },

    // Company stats section
    stats: {
      registeredCapital: 'Registered Capital (RMB)',
      yearsExperience: 'Years of Experience',
      factoryArea: 'Factory Area',
      crossBorderMarkets: 'Cross-border Markets'
    },

    // Tech features section
    techTitle: 'Technology & Innovation',
    techFeatures: {
      team: {
        title: 'Expert Team',
        desc: 'Professional team with extensive experience'
      },
      components: {
        title: 'Core Components',
        desc: 'Quality parts ensure reliable performance'
      },
      solutions: {
        title: 'Custom Solutions',
        desc: 'Tailored solutions for different needs'
      },
      standards: {
        title: 'International Standards',
        desc: 'Meeting global quality standards'
      }
    },

    // Video gallery section
    videoGallery: 'Video Gallery',
    factoryTour: 'Factory Tour',
    productDemo: 'Product Demonstration',
    exhibitionHighlights: 'Exhibition Highlights'
  },
  
  zh: {
    // Banner section
    slogan: '领先的农业机械解决方案',
    bannerSubtitle: '为现代农业提供创新的农机设备',
    shopNow: '立即选购',
    specialOffer: '特别优惠',
    offerDetails: '精选产品特惠折扣',
    viewOffer: '查看优惠',

    // Featured products section
    featuredProducts: '推荐产品',
    viewAllProducts: '查看全部产品',
    exploreProducts: '了解详情',
    newArrival: '新品',
    bestSeller: '热销',

    // Customer cases section
    customerCases: {
      title: '客户案例',
      subtitle: '来自全球合作伙伴的真实案例',
      procuredProducts: '采购产品',
      highlights: '合作亮点'
    },

    // Company intro section
    companyIntro: {
      title: '关于福田达',
      paragraph1: '福田达是农业机械制造领域的领军企业，专注于拖拉机和农业设备的研发生产。',
      paragraph2: '凭借20多年的行业经验，我们为现代农业提供创新解决方案。',
      paragraph3: '我们的产品远销50多个国家和地区，深受全球农户信赖。',
      paragraph4: '我们始终专注于品质、创新和客户满意度。',
      founded: '成立时间',
      capacity: '年产能力',
      engineers: '工程师',
      viewMore: '查看更多',
      countries: '出口国家'
    },

    // Company stats section
    stats: {
      registeredCapital: '注册资本（人民币）',
      yearsExperience: '行业深耕年限',
      factoryArea: '工厂面积',
      crossBorderMarkets: '跨境合作国家/地区'
    },

    // Tech features section
    techTitle: '技术实力',
    techFeatures: {
      team: {
        title: '专家团队',
        desc: '专业团队，经验丰富'
      },
      components: {
        title: '核心部件',
        desc: '优质零部件确保可靠性能'
      },
      solutions: {
        title: '定制方案',
        desc: '根据不同需求量身定制'
      },
      standards: {
        title: '国际标准',
        desc: '符合国际质量标准'
      }
    },

    // Video gallery section
    videoGallery: '视频展示',
    factoryTour: '工厂参观',
    productDemo: '产品演示',
    exhibitionHighlights: '展会亮点'
  }
} 